import {cloneDeep, get} from "lodash";
import {getNumber, getString} from "Core/helpers/data";
import {MyTicketsListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {MyTicketsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new MyTicketsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'ticketId'),
		getString(result, 'status'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getDate(get(result, 'creationDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getNumber(result, 'commentsNumber')
	);

	return result;
}

// @note There is no output function since list is read only.